import configJson from './config.json'
export const SEC = configJson.app_name